<template>
  <div :class="$style.root">
    <Stepper
      :total="maxQuestion"
      :current="currentStep"
    />
    <template v-if="question">
      <Question>
        <Anicss :enter-active-class="['animated', 'bounceIn']">
          <div :class="$style.playBtnBg" @click="showVideo" v-if="videoCanShow && hasVideoFiles">
            <SvgIcon
              :class="$style.playBtn"
              :svg="require('!svg-inline-loader?classPrefix!@mdi/svg/svg/video.svg')"
              button
              :size="60"
            />
          </div>
        </Anicss>
        <Anicss :enter-active-class="['animated', 'fadeIn']" :leave-active-class="['animated', 'fadeOut']">
          <VideoPlayer
            ref="player"
            v-show="isVideoActive"
            @close="hideVideo"
            @ended="hideVideo"
            :files="videoFiles"
          />
        </Anicss>
      </Question>
      <Choices :aside="aside" :readOnly="readOnly">
        <template v-if="!readOnly">
          <RightWordChoice
            v-for="(choice, n) in choices"
            :key="choice.id"
            :active="isSelected(n)"
            :word="choice.word"
            @click="canSelect ? reSelect(n) : null"
            :isAnswer="showAnswer ? isCorrectAnswer(n) : null"
          />
        </template>
        <template v-if="readOnly">
          <RightWordChoice
            v-for="(choice, n) in choices"
            :key="choice.id"
            :active="isSelected(n)"
            :word="choice.word"
            :isAnswer="isCorrectAnswer(n)"
          />
        </template>
      </Choices>
      <template v-if="!readOnly">
        <NextButton
          v-if="canProceed"
          @click="submitAnswer"
          :loading="isLoading"
          :disabled="disableNextButton"
        />
      </template>
      <template v-if="readOnly">
        <NextButton
          v-if="canReadNext"
          @click="readNextStep"
          noAni
        />
        <PrevButton
          v-if="canReadPrev"
          @click="readPrevStep"
          noAni
        />
      </template>
    </template>
  </div>
</template>

<script>
import exerciseMixin from '@/mixins/exercise'
import audioMixin from '@/mixins/audio'
import RightWordChoice from './RightWordChoice'
import SvgIcon from '@/components/SvgIcon'
import Modal from '@/components/Modal'
import Anicss from '@/components/Anicss'
import VideoPlayer from '@/components/VideoPlayer'

const config = {
  type: 'right-word',
}

export default {
  mixins: [exerciseMixin(config)],
  components: {
    RightWordChoice,
    SvgIcon,
    Modal,
    Anicss,
    VideoPlayer,
  },
  data () {
    return {
      isVideoActive: false,
      videoCanShow: false,
    }
  },
  async created () {
    await this.init()

    this.$on('result:start', () => {
      this.videoCanShow = true
    })
    this.$on('result:end', () => {
      this.videoCanShow = false
    })
  },
  computed: {
    hasVideoFiles () {
      return this.videoFiles && this.videoFiles.length > 0
    },
    videoFiles () {
      if (!this.question || !this.question.group) {
        return null
      }
      if (!this.question.group.audio) {
        return null
      }

      const file = require(`!file-loader!@/assets/video/right-word/${this.question.group.audio}`)
      if (!file) {
        return null
      }
      return [file]
    },
    timeLimit () {
      return this.history.level == '1'
        ? 3000
        : 4000
    },
  },
  methods: {
    showVideo () {
      this.isVideoActive = true
      this.$refs.player.play()
    },
    hideVideo () {
      this.isVideoActive = false
      this.$refs.player.stop()
    },
  },
}
</script>

<style lang="scss" module>
.root {}

.playBtn {
  background-color: rgba(152, 223, 226, 0.88);
  padding: 16px 40px;
  @apply rounded;
  @apply shadow;
}

.player {
  margin: 1rem 2rem;

  @screen lg {
    margin: 1rem 4rem;
  }
}
</style>
